module.exports = __webpack_public_path__ + "static/img/ic_video_stop_land.c4a06951.png";